const computeDownPayment = (total, ratio) => {
    const loan = parseInt(total * (1 - ratio) / 10000) * 10000
    return ((total - loan) / 10000).toFixed(2)
}

export const handleItem = (item, option) => {
    let { decorate_price, downpayment_percentage } = option
    decorate_price = item.decorate_price || decorate_price
    const show_decorate_price = item.decoration_type !== '清水' ? decorate_price : 0
    const { area } = item

    const total_origin_price = item.water_price + show_decorate_price * area
    const square_price_show = Math.round(total_origin_price / area)

    const total_price = (total_origin_price / 10000).toFixed(2)
    const [rd_ratio, normal_ratio] = downpayment_percentage

    const down_payment_rd = computeDownPayment(total_origin_price, rd_ratio)
    const down_payment_normal = computeDownPayment(total_origin_price, normal_ratio)

    const ratio_map = {
        '0.1': '一成',
        '0.2': '二成',
        '0.3': '三成',
        '0.4': '四成',
        '0.5': '五成',
        '0.6': '六成',
        '0.7': '七成',
        '0.8': '八成',
        '0.9': '九成'
    }
    const rd_ratio_tx = ratio_map[rd_ratio]
    const normal_ratio_tx = ratio_map[normal_ratio]
    return {
        ...item,
        disabled: item.status && item.status != '可售',
        show_decorate_select: Number(item.decorate_price) === 0,
        area,
        show_decorate_price,
        square_price_show,
        total_price,
        rd_ratio_tx,
        normal_ratio_tx,
        down_payment_rd,
        down_payment_normal
    }
}